import React, { FC } from "react";
import { IDetailNftData } from "../../../../common/interfaces/common.interface";
import CustomCheckbox from "../../../CustomCheckbox/CustomCheckbox";
import NftCard from "../../../NftCard/NftCard";
import "./NftVotingCard.scss";

const NftVotingCard: FC<{
  nft: IDetailNftData;
  isNftSelected: boolean;
  chooseNft: (nft: IDetailNftData) => void;
}> = ({ nft, isNftSelected, chooseNft }) => {
  const selectNft = () => {
    chooseNft(nft);
  };

  return (
    <div
      onClick={selectNft}
      className={`${
        isNftSelected ? "nft-voting-card active" : "nft-voting-card"
      }`}
    >
      <div className="nft-voting-card__checkbox">
        <CustomCheckbox onClickMethod={() => {}} checked={isNftSelected} />
      </div>

      <NftCard nft={nft} />
    </div>
  );
};

export default NftVotingCard;
